import { MALWARE_ICON } from 'constants/all';

/**
 * @deprecated use icons from '@frontend/components' instead.
 */
const MalwareIcon = (props) => (
  <img {...props} src={MALWARE_ICON} alt="File Containing Malware" />
);

export default MalwareIcon;
